import { useContext, useMemo, useState } from "react"
import { motion } from "framer-motion"
import { Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import { MdDeleteOutline } from "react-icons/md"

import TopoMenu from "../../../componentes/gerais/TopoMenu"
import MenuLateral from "../../../componentes/gerais/Menu"
import { configAnim } from "../../../servicos/config/configAnim"
import { ContextoGeral } from "../../../contextos/ContextoGeral"
import ProfissionalAPI from "../../../servicos/ProfissionalAPI"

export default function ExcluirConta() {
	const { dados, limparSessaoLocal } = useContext(ContextoGeral)

	const [menu, setMenu] = useState(false)
	const [openConfirm, setOpenConfirm] = useState(false)
	const [carregando, setCarregando] = useState(false)
	const [retorno, setRetorno] = useState(null)

	const nomeProfissional = useMemo(() => dados?.nome || "Profissional", [dados?.nome])

	async function confirmarExclusao() {
		setCarregando(true)
		setRetorno(null)

		const resposta = await ProfissionalAPI.excluirConta(dados)

		if (resposta?.resultado) {
			setRetorno({
				tipo: "success",
				mensagem: resposta?.mensagem || "Conta excluída com sucesso."
			})
			setOpenConfirm(false)
			setTimeout(() => limparSessaoLocal(dados.dominio), 1200)
		} else {
			setRetorno({
				tipo: "error",
				mensagem: resposta?.mensagem || "Não foi possível excluir sua conta agora."
			})
		}

		setCarregando(false)
	}

	return (
		<motion.div
			initial={configAnim.initial}
			animate={configAnim.animate}
			exit={configAnim.exit}
			transition={configAnim.transition}
			className="min-h-lvh bg-white"
		>
			<TopoMenu voltar="/app/perfil" titulo="EXCLUIR CONTA" setShow={setMenu} />

			<div className="px-4 py-5">
				<div className="rounded-4 border border-red-200 bg-red-50 px-4 py-4 shadow-sm">
					<div className="flex items-center gap-3 text-red-700">
						<MdDeleteOutline size={30} />
						<h4 className="mb-0 font-semibold">Excluir perfil</h4>
					</div>

					<p className="mt-3 mb-2 text-sm text-slate-700">
						Profissional: <strong>{nomeProfissional}</strong>
					</p>
					<p className="mb-4 text-sm text-slate-700">
						Essa ação desativa sua conta, encerra sua sessão atual e impede novos acessos com este cadastro.
					</p>

					<Button
						fullWidth
						color="error"
						variant="contained"
						size="large"
						disabled={carregando}
						onClick={() => setOpenConfirm(true)}
						startIcon={carregando ? <CircularProgress size={18} color="inherit" /> : <MdDeleteOutline />}
					>
						{carregando ? "Excluindo..." : "Excluir conta"}
					</Button>
				</div>

				<div className="mt-4 text-sm text-slate-500">
					Você será redirecionado para a tela inicial após a confirmação da exclusão.
				</div>

				{retorno && (
					<Alert severity={retorno.tipo} className="mt-4">
						{retorno.mensagem}
					</Alert>
				)}
			</div>

			<Dialog open={openConfirm} onClose={() => !carregando && setOpenConfirm(false)} fullWidth maxWidth="xs">
				<DialogTitle>Confirmar exclusão</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Deseja realmente excluir sua conta? Essa ação vai desativar seu perfil e encerrar seu acesso ao aplicativo.
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button disabled={carregando} onClick={() => setOpenConfirm(false)}>
						Cancelar
					</Button>
					<Button color="error" variant="contained" disabled={carregando} onClick={confirmarExclusao}>
						Confirmar exclusão
					</Button>
				</DialogActions>
			</Dialog>

			<MenuLateral show={menu} setShow={setMenu} />
		</motion.div>
	)
}
